/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable no-console */
import {useNavigate} from 'react-router-dom';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';
import {toast} from 'react-toastify';
import {format} from 'date-fns';

import type {DataPlanTemplate, UsageThreshold} from 'interfaces';
import {useDeleteDataPlanTemplateMutation} from 'services';
import {PERIOD_MAP} from 'constants/resetPeriods';

import 'react-confirm-alert/src/react-confirm-alert.css';

type TProps = {
	dataPlan: DataPlanTemplate[] | null;
	onCleanPlans: (item: DataPlanTemplate, type: string) => void;
	isDisabled: boolean;
};
const TableSubscritionPlan = ({dataPlan, onCleanPlans, isDisabled}: TProps) => {
	const navigate = useNavigate();

	const [deleteRow] = useDeleteDataPlanTemplateMutation();

	/**
	 * It returns an object with the properties that the modal component needs to render
	 * @param {DataPlanTemplate} item - DataPlanTemplate - The item that is being passed to the modal.
	 */
	const optionsRemoveModal = (item: DataPlanTemplate | any) => ({
		title: 'Do you really want to remove the plan named' + item?.name + '?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: async () => {
					try {
						void deleteRow(item?.name);
						onCleanPlans(item, 'plan');
						toast.success('Deleted Plan Successfully!');
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	const handleRemove = (item: DataPlanTemplate) =>
		confirmAlert(optionsRemoveModal(item));

	function formatUsageThreshold(threshold: UsageThreshold) {
		if (threshold.totalVolume) {
			return `${threshold.totalVolume} ${threshold.totalVolumeUnit || '-'}`;
		} else if (threshold.duration) {
			return `${threshold.duration} ${threshold.durationUnit || 'min'}`;
		} else if (threshold.uplinkVolume || threshold.downlinkVolume) {
			return `${threshold.uplinkVolume} ${threshold.uplinkVolumeUnit || '-'} /
				    ${threshold.downlinkVolume} ${threshold.downlinkVolumeUnit || '-'}`;
		} else {
			return 'Unlimited';
		}
	}

	return (
		<div className="panel-body">
			<div className="col-md-12 mt-4 ">
				{' '}
				<div className="table-responsive h500 mt-2">
					{dataPlan ? (
						<table className="table table-striped table-sm table-head-fixed text-nowrap">
							<thead>
								<tr>
									<th className="col-1">Name</th>
									<th className="col-1">Activation Date</th>
									<th className="col-1">Expiration Date</th>
									<th className="col-1">Mode</th>
									<th className="col-1">Period of Use</th>
									<th className="col-1">Threshold</th>
									{!isDisabled && <th className="col-1">Actions</th>}
								</tr>
							</thead>
							<tbody>
								{dataPlan?.map((el: DataPlanTemplate, key: number) => (
									<tr key={key}>
										<td>{el.name ?? '-'}</td>
										<td>
											{el?.activationDate
												? format(
														new Date(el?.activationDate),
														'yyyy/MM/dd HH:MM',
												  )
												: '-'}
										</td>
										<td>
											{el?.expirationDate
												? format(
														new Date(el?.expirationDate),
														'yyyy/MM/dd HH:MM',
												  )
												: '-'}
										</td>
										<td>
											{(() => {
												const maxNum = el?.resetPeriod?.maxNumPeriod;
												if (maxNum === undefined) return '-';
												if (maxNum === 1) return 'One Time';
												if (maxNum === 0) return 'Recurrent Unlimited';
												if (maxNum > 1) return 'Recurrent';
												return '-';
											})()}
										</td>
										<td>
											{(() => {
												const maxNum = el?.resetPeriod?.maxNumPeriod;
												const period = el?.resetPeriod?.period;
												if (
													maxNum === undefined ||
													maxNum === 0 ||
													maxNum === 1
												) {
													return 'N/A';
												}
												return `${maxNum} ${
													period ? PERIOD_MAP[period] ?? period : ''
												}`;
											})()}
										</td>
										<td>
											{el.usageThreshold
												? formatUsageThreshold(el.usageThreshold)
												: 'Unlimited'}
										</td>
										{!isDisabled && (
											<td>
												<button
													className="border-0 bg-transparent d-inline"
													onClick={() =>
														navigate(
															`/subscriberPlan/detail/${el.name as never}`,
															{
																state: el,
															},
														)
													}>
													<i
														className="bi-1 bi-pencil"
														title="Edit"
														data-toggle="tooltip"
													/>
												</button>

												<button
													className="border-0 bg-transparent d-inline"
													onClick={() => handleRemove(el)}>
													<i
														className="bi-1 bi-trash-fill text-danger"
														title=""
														data-toggle="tooltip"
														data-original-title="Delete"
													/>
												</button>
											</td>
										)}
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<div className="text-center">
							<span className="h6">No data</span>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default TableSubscritionPlan;
